// Collapse/expand support for the org chart. Pure, unit-tested.

// hiddenDescendants returns the set of node ids that should be hidden because one of their
// ancestors is collapsed: every descendant of any id in collapsedIds (the collapsed nodes
// themselves stay visible). `edges` is an array of { parent, child } string ids (top-level
// nodes use parent "root" or null).
export function hiddenDescendants(collapsedIds, edges) {
  const childrenOf = new Map();
  for (const e of edges) {
    if (e.parent == null) continue;
    if (!childrenOf.has(e.parent)) childrenOf.set(e.parent, []);
    childrenOf.get(e.parent).push(e.child);
  }

  const hidden = new Set();
  const stack = [];
  for (const id of collapsedIds) {
    for (const c of childrenOf.get(id) || []) stack.push(c);
  }
  while (stack.length) {
    const n = stack.pop();
    if (hidden.has(n)) continue;
    hidden.add(n);
    for (const c of childrenOf.get(n) || []) stack.push(c);
  }
  return hidden;
}
